import { getBrandCountries, getDefaultCountry, getMapCountrySite, getCountryName, getLanguageName, } from '../../countries';
import { getGlobalEData, getLocale, handleGlobalEBanner } from '../globalE';
export default async () => {
    const changeCountry = document.querySelector('#footer-change-country [data-change-country]');
    if (!changeCountry)
        return;
    const countries = getBrandCountries();
    const globalEData = getGlobalEData();
    const defaultCountry = getDefaultCountry();
    if (!globalEData || !defaultCountry)
        return;
    // Display default country code from GlobalE cookie
    const mapCountrySite = getMapCountrySite();
    const countrySite = mapCountrySite[globalEData.countryISO];
    const userCountry = countries.find((c) => c.label === globalEData.countryISO);
    const userCountryCode = userCountry && countrySite && window.location.pathname.startsWith(`/${countrySite}`)
        ? userCountry.label
        : defaultCountry.code;
    // Handle click on country name
    changeCountry.addEventListener('click', (e) => {
        e.stopPropagation();
        handleGlobalEBanner(true);
    });
    // Display translated country label
    const countryName = await getCountryName(userCountryCode);
    changeCountry.innerHTML = countryName;
    const changeLanguage = document.querySelector('#footer-change-country [data-change-language]');
    if (!changeLanguage)
        return;
    // Handle click on country name
    changeLanguage.addEventListener('click', (e) => {
        e.stopPropagation();
        handleGlobalEBanner(true);
    });
    // Display translated language label
    const languageName = await getLanguageName(getLocale());
    changeLanguage.innerHTML = languageName;
};
